import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PagedRequestOptions } from './solicitar-visita.service';

// Interfaz extendida para incluir filtros específicos de este reporte
export interface ActivosPagedRequestOptions extends PagedRequestOptions {
  localId?: number;
}

@Injectable({
  providedIn: 'root'
})

export class ActivoFijoLocalService {

  private apiUrl = `${environment.apiUrl}/activo-fijo-local`;
  private masivaUrl = `${environment.apiUrl}/activo-fijo-local-masiva`;

  constructor( private http: HttpClient ) { }

   /**
   * Obtiene una lista paginada, filtrada y ordenada de Activos Fijos.
   * Reemplaza a los antiguos métodos 'listar' y 'exportar'.
   */
  getActivosFijosPaginado(options: ActivosPagedRequestOptions): Observable<any> {
    const params = this.buildHttpParams(options);
    return this.http.get<any[]>(this.apiUrl, { params });
  }

  private buildHttpParams(options: ActivosPagedRequestOptions): HttpParams {
    let params = new HttpParams();

    if (options.export) {
      params = params.set('export', 'true');
    } else {
      if (options.page) params = params.set('page', options.page.toString());
      if (options.limit) params = params.set('limit', options.limit.toString());
    }

    if (options.clientId) params = params.set('clientId', options.clientId.toString());
    if (options.localId) params = params.set('localId', options.localId.toString());
    if (options.searchTerm?.trim()) params = params.set('searchTerm', options.searchTerm.trim());
    if (options.sortBy) params = params.set('sortBy', options.sortBy);
    if (options.sortOrder) params = params.set('sortOrder', options.sortOrder);

    return params;
  }

  /**
   * Obtiene la plantilla Excel con Data Validation para la carga masiva.
   * @param clientId ID del cliente seleccionado.
   */
  descargarPlantillaMasiva(clientId: number): Observable<Blob> {
    return this.http.get(`${this.masivaUrl}/descargar-plantilla/${clientId}`, { 
      responseType: 'blob' 
    });
  }

  /**
   * Guarda los datos del Excel en la tabla intermedia del backend.
   */
  guardarCargaMasiva(clientId: number, datos: any[]): Observable<any> {
    return this.http.post(`${this.masivaUrl}/guardar-carga`, { clientId, datos });
  }

  /**
   * Obtiene los registros intermedios pendientes o con error para un cliente.
   */
  findCargaPendiente(clientId: number): Observable<any[]> {
    const params = new HttpParams().set('clientId', clientId.toString());
    return this.http.get<any[]>(`${this.masivaUrl}/carga-pendiente`, { params });
  }

  /**
   * Obtiene un registro intermedio por ID para su edición.
   */
  getRegistroIntermedioById(id: number): Observable<any> {
    return this.http.get<any>(`${this.masivaUrl}/carga-pendiente/${id}`);
  }
  
  /**
   * Actualiza un registro intermedio.
   */
  updateRegistroIntermedio(id: number, data: Partial<any>): Observable<any> {
    return this.http.put(`${this.masivaUrl}/carga-pendiente/${id}`, data);
  }

  /**
   * Ejecuta el proceso final de validación e inserción de la tabla intermedia a la tabla final.
   */
  ejecutarProcesoMasivo(clientId: number): Observable<any> {
    return this.http.post<any>(`${this.masivaUrl}/ejecutar-proceso`, { clientId });
  }

  listar = () => this.http.get<any>(`${this.apiUrl}`);
  getById = (id: number) => this.http.get<any>(`${this.apiUrl}/${id}`);
  crear = (data: any) => this.http.post<any>(`${this.apiUrl}`, data);
  actualizar = (data: any) => this.http.put<any>(`${this.apiUrl}/${data.id}`, data);
  eliminar = (id: number) => this.http.delete<any>(`${this.apiUrl}/${id}`);
  getActivosFijosByLocal = (localId: number) => this.http.get<any>(`${this.apiUrl}/local/${localId}`);
 
  restaurarActivoFijoLocal(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/restaurar`, {});
  }
}
